// Anonymous upload-link endpoints answer 401 for a rejected link code, email or password, not for an expired token
export const UPLOAD_LINK_ENDPOINTS = [
  'CheckCode',
  'LoginByCode',
  'UploadsByCode',
  'DeleteUploadByCode',
  'uploadXmlWithCode',
  'uploadFilesWithCode',
  'uploadXmlByIdWithCode',
  'ChangeStatusFilesWithCode',
  'CheckUploadNameWithCode',
];
